"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleTransformSchema = void 0;
const zod_1 = require("zod");
const XYPosition_1 = require("./XYPosition");
exports.ModuleTransformSchema = zod_1.z.object({
    pos: XYPosition_1.XYPositionSchema.optional(),
    angle: zod_1.z.number().transform((a) => a ?? 0),
    mirrored: zod_1.z.boolean().array(),
});
//# sourceMappingURL=ModuleTransform.js.map